export const EstatusMovimientoEnum = Object.freeze({
  INACTIVO: 0,
  ACTIVO: 1,
  APARTADO: 2,
  EN_TRANSITO: 3,
  EN_RECONOCIMIENTO: 4,
  CANCELADO: 5,
  CARGADO: 6,
  PROCESADO: 7,
  ENVIADO: 8,
  INACTIVO_AJUSTE: 9,
  APARTADO_AJUSTE: 10,
  INACTIVO_SALIDA: 11,
  APARTADO_SALIDA: 12
})

export const MovStatusArray = [
  {
    id: 0,
    name: "Inactivo",
  },
  {
    id: 1,
    name: "Activo",
  },
  {
    id: 2,
    name: "Apartado",
  },
  {
    id: 3,
    name: "En Tránsito",
  },
  {
    id: 4,
    name: "En Reconocimiento",
  },
  {
    id: 5,
    name: "Cancelado",
  },
  {
    id: 6,
    name: "Cargado",
  },
  {
    id: 7,
    name: "Procesado",
  },
  {
    id: 8,
    name: "Enviado",
  },
  {
    id: 9,
    name: "Inactivo Ajuste",
  },
  {
    id: 10,
    name: "Apartado Ajuste",
  },
  {
    id: 11,
    name: "Inactivo Salida",
  },
  {
    id: 12,
    name: "Apartado Salida",
  }
]